
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class DimensionSelect extends Vue {
  @Prop({ type: String, default: "" }) text!: string;
  @Prop({ type: String, default: "top" }) place!: string; //出现位置
  @Prop({ type: Number, default: 14 }) fontSize!: string;
  @Prop({ type: Boolean, default: false }) big!: boolean; //
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  mounted() {
    //
  }
}
